// @flow @format
import React, {PureComponent} from 'react';
import DiskIcon from '../../components/Icon/hdd-o';
import {Link} from 'react-router';
import './Breadcrumb.css';
import {encodeEmail} from 'lib/cloner-api/util';

import type {FileNode} from 'lib/cloner-api';

type Props = {
	userId: string,
	machineId: string,
	fileNode: ?FileNode,
};

class Breadcrumb extends PureComponent<Props> {
	render() {
		const {fileNode, userId, machineId} = this.props;

		if (!fileNode) {
			return <div className="Breadcrumb" />;
		}

		const {breadcrumb, repository} = fileNode;
		const len = breadcrumb.length;
		const sorted = [];

		for (let i = 1; i < len; i++) {
			sorted[i] = breadcrumb[len - 1 - i];
		}

		return (
			<div className="Breadcrumb">
				{sorted.map((item, index) =>
					<div key={item.id} className="Breadcrumb__Item">
						{index === len - 1 &&
							<div className="Breadcrumb__Link">
								{index === 0 &&
									<DiskIcon className="Breadcrumb__Icon" />}
								{item.name.replace(/[\\/]$/, '')}
							</div>}
						{index !== len - 1 &&
							<Link
								className="Breadcrumb__Link"
								to={`/explorer/files/${repository.id}/${item.id}?userId=${encodeEmail(
									userId
								)}&machineId=${machineId}`}
							>
								{index === 0 &&
									<DiskIcon className="Breadcrumb__Icon" />}
								{item.name.replace(/[\\/]$/, '')}
							</Link>}
					</div>
				)}
			</div>
		);
	}
}

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/Breadcrumb.js